var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTorresFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009966;}\n\t.st1{fill:#000099;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect2160",
    x: 0,
    y: 495,
    className: "st0",
    width: 900,
    height: 105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect3198",
    x: 0,
    className: "st0",
    width: 900,
    height: 105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect3200",
    x: 0,
    y: 105,
    width: 900,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4171",
    x: 0,
    y: 465,
    width: 900,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4173",
    x: 0,
    y: 135,
    className: "st1",
    width: 900,
    height: 330
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5162",
    className: "st2",
    d: "M435,142.5c-150,45-142.5,157.5-94.5,261l-57,54L387,420V282c33-49.5,93-49.5,126,0v138 l103.5,37.5l-57-54c48-103.5,55.5-216-94.5-261L450,207L435,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6829",
    className: "st2",
    d: "M507,295.6l-35,26.9l13.3,43.5L450,339.3l-35.2,26.7l13.2-43.5l-35-27l43.4-0.1L450,252 l13.6,43.4L507,295.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorresFlag);
export default __webpack_public_path__ + "static/media/torresFlag.4ddb988ba63220562fe901885aa2f9ff.svg";
export { ForwardRef as ReactComponent };